<swiper-container class="image-gallery" #imageGallery init="false">
  <swiper-slide *ngFor="let slide of slides">
    <div
      [ngClass]="{
        'no-side-nav-pd': !config.navigation,
        'no-bottom-nav-pd': !config.pagination
      }"
      class="image-gallery__img-container"
    >
      <img [alt]="slide.alt" [src]="slide.src" loading="eager" />
    </div>
  </swiper-slide>
</swiper-container>
